import type { SessionService } from '@empathyco/x-utils'

import type { ActionContext } from 'vuex'

import type { ActionClass, AuthState } from '../../../models'
import type { StorageService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { AUTH_CONSTS } from '../../auth/auth.consts'

export class LogoutAction implements ActionClass {
  static async execute(this: void, { dispatch }: ActionContext<AuthState, any>): Promise<void> {
    await dispatch(AUTH_CONSTS.actions.reset)
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
    storageService.removeItem(AUTH_CONSTS.storage.token)
    storageService.removeItem(AUTH_CONSTS.storage.refreshToken)
    storageService.removeItem(AUTH_CONSTS.storage.keepLoggedIn)
    CONTAINER.get<SessionService>(TYPES.SessionService).clearSessionId()
  }
}
